import {
  createContext,
  Dispatch,
  ReactNode,
  SetStateAction,
  useCallback,
  useContext,
  useState,
} from "react";
import { CheckoutService } from "../../services/Checkout/CheckoutService";
import { ToastSettings } from "../../utils/ToastSettings";

interface ContextProps {
  articlePlatform: any[];
  isLoading: boolean;
  error: string;
  setError: Dispatch<SetStateAction<string>>;
  handleListArticlesPlatform: () => void;
  handleFetch: (data: any) => Promise<{ success: boolean; id: number }>;
}

export const CheckoutContext = createContext<ContextProps>({} as ContextProps);

interface CheckoutProviderProps {
  children: ReactNode;
}

export const CheckoutProvider = ({ children }: CheckoutProviderProps) => {
  const [articlePlatform, setArticlePlatform] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [error, setError] = useState<string>("");

  const service = new CheckoutService();

  const handleListArticlesPlatform = useCallback(async () => {
    try {
      setIsLoading(true);
      const [_Response, _Error] = await service.list();
      setIsLoading(false);

      if (!!_Error) {
        return setError(_Response?.message || _Error);
      }

      setArticlePlatform(_Response?.data);
      return setError("");
    } catch (e) {
      setIsLoading(false);
      setError("Não foi possível carregar os planos do sistema.");
    }
  }, []);

  const handleFetch = async (data: any) => {
    try {
      setIsLoading(true);
      const [_Response, _Error, _Code, _Errors] = await service.fetch(data);
      setIsLoading(false);
      if (!!_Error) {
        ToastSettings(
          _Response?.message || _Error,
          "bottom-center",
          "error",
          () => {},
          _Errors,
        );
        return { success: false, id: 0 };
      }

      setError("");
      return { success: true, id: _Response?.data?.subscription_id };
    } catch (e) {
      setError("Houve um erro ao contratar plano");
      setIsLoading(false);
      return { success: false, id: 0 };
    }
  };

  return (
    <CheckoutContext.Provider
      value={{
        isLoading,
        articlePlatform,
        error,
        setError,
        handleListArticlesPlatform,
        handleFetch,
      }}
    >
      {children}
    </CheckoutContext.Provider>
  );
};

export const useCheckout = () => useContext(CheckoutContext);
